import { BlokItem, DynamicRender, sbEditable, SBProps } from '../../../utils';

interface SBPreHeaderProps {
  body?: BlokItem[];
}

export const SBPreHeader = ({ blok }: SBProps<SBPreHeaderProps>) => {
  const { body } = blok;

  return (
    <div {...sbEditable(blok)}>
      <DynamicRender data={body} />
    </div>
  );
};
